import { render, staticRenderFns } from "./RedeemAccessKey.vue?vue&type=template&id=c84d1006&scoped=true&"
import script from "./RedeemAccessKey.vue?vue&type=script&lang=js&"
export * from "./RedeemAccessKey.vue?vue&type=script&lang=js&"
import style0 from "./RedeemAccessKey.vue?vue&type=style&index=0&id=c84d1006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84d1006",
  null
  
)

export default component.exports